module.exports = "/assets/9547134a684b76e36814913d693f39bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/3L.png
// module id = 1012
// module chunks = 0